import script from "./InstagramFeed.vue?vue&type=script&setup=true&lang=ts"
export * from "./InstagramFeed.vue?vue&type=script&setup=true&lang=ts"

import "./InstagramFeed.vue?vue&type=style&index=0&id=dcc6daca&scoped=true&lang=css"

import exportComponent from "../../../eckpunkt-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dcc6daca"]])

export default __exports__